import { createContext } from "react";
import type { ConditionEqualityType } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import { conditionOperatorOptions } from "./conditionOperatorOptions.ts";

export interface ConditionFilterOptions {
  operators: ConditionEqualityType[];
}

const ConditionFilterOptionsContext = createContext<ConditionFilterOptions>({
  operators: conditionOperatorOptions.map((option) => option.value),
});

export default ConditionFilterOptionsContext;
